import { URLS, PAYMENT_METHODS, DATA_LAYER_EVENTS } from 'common/constants';
import {
  usePersistedBranchId,
  usePersistedCartData,
  usePersistedCurrentEvent,
  usePersistedVoucherError,
  usePersistedWalletUsed,
} from 'common/hooks';
import { RenderingRegistry } from 'common/lib/registries';
import { useCheckout, useUserInfo } from 'service/hooks';
import { Checkout, DeliveryZoneMs, RecipientInfo } from 'service/types';
import { changeRoute } from 'common/utils';

type checkoutVariablesType = {
  isScheduled: boolean;
  expectedAt?: string;
  isGift?: boolean;
  isWalletUsed?: boolean;
  timeSlot?: string;
  addressId?: string;
  roundingAmount: number;
  paymentGatewayId?: string;
  paymentMethodId?: string;
  paymentType: string;
  paymentOption?: string;
  paymentToken?: string;
  carId?: string;
  recipient?: RecipientInfo;
  deliveryZone?: DeliveryZoneMs;
  umbrellaNumber?: string;
  umbrellaInstructions?: string;
  language: number;
};

type useHandleCheckoutType = () => (
  variables: checkoutVariablesType,
  onComplete?: (res: any) => void,
) => Promise<void | Partial<Checkout>>;

const useHandleCheckout: useHandleCheckoutType = () => {
  const [cartData, ,] = usePersistedCartData();
  const [branchId] = usePersistedBranchId();
  const [, , removeVoucherError] = usePersistedVoucherError();
  const [currentEvent, setPersistedCurrentEvent] = usePersistedCurrentEvent();
  const isManualOrder = RenderingRegistry.getIsManualOrder();
  const [, , removeIsWallet] = usePersistedWalletUsed();
  const { mutate: refetchUserInfo } = useUserInfo();
  const checkout = useCheckout({ ...cartData, branchId });
  const handleCheckout = async (variables: checkoutVariablesType, onComplete: (res: any) => void) => {
    const response: any = await checkout(variables);

    if (!response?.hasError) {
      onComplete?.(response);
      refetchUserInfo();
      if (isManualOrder) {
        await changeRoute({
          pathname: URLS.SENT_CART_LINK,
          query: {
            state: response && PAYMENT_METHODS.OFFLINE,
            id: response && PAYMENT_METHODS.OFFLINE && response?.orderNumber,
          },
        });
      } else {
        await setPersistedCurrentEvent({ ...currentEvent, [DATA_LAYER_EVENTS.PURCHASE]: response?.orderNumber });
        await changeRoute({
          pathname: URLS.STATUS,
          query: { id: response && response.orderNumber },
        });
      }
      removeVoucherError();
      removeIsWallet();
      RenderingRegistry.clearRegistry();
    }
  };

  return handleCheckout;
};

export default useHandleCheckout;
